import { Route, Routes } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { useEffect } from 'react';
import { toast } from 'material-react-toastify';
import { OrdersPage } from './OrdersPage';
import { OrderDetailsPage } from './OrderDetails/OrderDetailsPage';
import { shippingProvidersAtom } from '../../atoms/ShippingProvider';
import { getShippingProviders } from '../../api/ShippingProvider';
import { CollectOrderPage } from './CollectOrderPage/CollectOrderPage';
import { ScanOrderCargoNoPage } from './ScanOrderCargoNoPage';

export const OrderPageRoot = () => {
  const setShippingProviders = useSetRecoilState(shippingProvidersAtom);

  useEffect(() => {
    getShippingProviders()
      .then((s) => setShippingProviders(s))
      .catch((err) => toast.error(err.message));
  }, []);

  return (
    <Routes>
      <Route path='/:orderID/collect' element={<CollectOrderPage />} />
      <Route path='/scan' element={<ScanOrderCargoNoPage />} />
      <Route path='/:orderID' element={<OrderDetailsPage />} />
      <Route path='*' element={<OrdersPage />} />
    </Routes>
  );
};
